<div class="filters-container">
    <div class="filter-item" *ngFor="let filter of filters" [class.filter-item--push-right]="filter.type === 'search'">
        <!-- Dropdown Filter -->
        <ng-container *ngIf="filter.type === 'dropdown'">
            <i *ngIf="filter.icon" class="bi bi-{{ filter.icon }}"></i>
            <div class="custom-dropdown-wrapper" [class.open]="dropdownStates[filter.key]">
                <!-- Trigger Button -->
                <div class="custom-dropdown-trigger" (click)="toggleDropdown(filter.key)">
                    <span class="selected-text">
                        {{ getSelectedLabel(filter) }}
                    </span>
                    <img src="assets/icons/direction-down01.svg" class="dropdown-arrow" alt="arrow" />
                </div>

                <!-- Dropdown Menu -->
                <div class="custom-dropdown-menu" *ngIf="dropdownStates[filter.key]">
                    <div class="dropdown-item" [class.active]="filterValues[filter.key] === ''"
                        (click)="selectOption(filter.key, '', filter.placeholder || 'All')">
                        {{ filter.placeholder || 'All' }}
                    </div>
                    <div class="dropdown-item" *ngFor="let option of filter.options"
                        [class.active]="filterValues[filter.key] === option.value"
                        (click)="selectOption(filter.key, option.value, option.label)">
                        {{ option.label }}
                    </div>
                </div>
            </div>
        </ng-container>


        <!-- Date Range Filter -->
        <ng-container *ngIf="filter.type === 'daterange'">
            <app-date-range-picker [placeholder]="filter.placeholder || 'Select Date Range'"
                (dateRangeChange)="onDateRangeChange(filter.key, $event)">
            </app-date-range-picker>
        </ng-container>


        <!-- Search Filter -->
        <ng-container *ngIf="filter.type === 'search'">
            <div class="search-container">
                <div class="search-icon-wrapper">
                    <img src="assets/icons/zoom-text.svg" alt="Down Direction Arrow" width="16" height="16" />
                </div>
                <input type="text" class="search-input" [(ngModel)]="filterValues[filter.key]"
                    (input)="onFilterChange(filter.key, filterValues[filter.key])"
                    [placeholder]="filter.placeholder || 'Search...'">
            </div>
        </ng-container>
    </div>

    <!-- Clear Filters Button -->
    <button *ngIf="hasActiveFilters()" class="btn btn-outline-secondary btn-sm" (click)="clearFilters()">
        <i class="bi bi-x-circle"></i> Clear Filters
    </button>
</div>